"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.3.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
class Client {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }
    /**
     * @return openapi.json
     */
    getPlainOpenApiJson(cancelToken) {
        let url_ = this.baseUrl + "/openapi.json";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPlainOpenApiJson(_response);
        });
    }
    processGetPlainOpenApiJson(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return array for NlpProcessors
     */
    getConfig(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/config";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetConfig(_response);
        });
    }
    processGetConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Config.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return array for NlpProcessors
     */
    getNlpProcessors(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/nlp-processors";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNlpProcessors(_response);
        });
    }
    processGetNlpProcessors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NlpProcessor.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param body (optional)
     * @return a NlpProcessor
     */
    createNlpProcessor(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/nlp-processors";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateNlpProcessor(_response);
        });
    }
    processCreateNlpProcessor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NlpProcessor.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param nlpProcessorId nlpProcessorId
     * @return Nlp Processor
     */
    getNlpProcessor(accountId, projectId, versionId, nlpProcessorId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/nlp-processors/{nlpProcessorId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (nlpProcessorId === undefined || nlpProcessorId === null)
            throw new Error("The parameter 'nlpProcessorId' must be defined.");
        url_ = url_.replace("{nlpProcessorId}", encodeURIComponent("" + nlpProcessorId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNlpProcessor(_response);
        });
    }
    processGetNlpProcessor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NlpProcessor.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param nlpProcessorId nlpProcessorId
     * @return Nlp Processor
     */
    deleteNlpProcessor(accountId, projectId, versionId, nlpProcessorId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/nlp-processors/{nlpProcessorId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (nlpProcessorId === undefined || nlpProcessorId === null)
            throw new Error("The parameter 'nlpProcessorId' must be defined.");
        url_ = url_.replace("{nlpProcessorId}", encodeURIComponent("" + nlpProcessorId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteNlpProcessor(_response);
        });
    }
    processDeleteNlpProcessor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NlpProcessor.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param nlpProcessorId nlpProcessorId
     * @param body (optional)
     * @return NlpProcessor
     */
    updateNlpProcessor(accountId, projectId, versionId, nlpProcessorId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/nlp-processors/{nlpProcessorId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (nlpProcessorId === undefined || nlpProcessorId === null)
            throw new Error("The parameter 'nlpProcessorId' must be defined.");
        url_ = url_.replace("{nlpProcessorId}", encodeURIComponent("" + nlpProcessorId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateNlpProcessor(_response);
        });
    }
    processUpdateNlpProcessor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NlpProcessor.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return array for Account Items
     */
    getAccounts(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAccounts(_response);
        });
    }
    processGetAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Account.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return a Account
     */
    createAccount(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateAccount(_response);
        });
    }
    processCreateAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Account.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @return Account
     */
    getAccount(accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAccount(_response);
        });
    }
    processGetAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Account.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @return removed the Account
     */
    deleteAccount(accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteAccount(_response);
        });
    }
    processDeleteAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Account.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param body (optional)
     * @return Account
     */
    updateAccount(accountId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateAccount(_response);
        });
    }
    processUpdateAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Account.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @return array for  Project Items
     */
    getProjects(accountId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetProjects(_response);
        });
    }
    processGetProjects(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Project.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param body (optional)
     * @return a Project
     */
    createProject(accountId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateProject(_response);
        });
    }
    processCreateProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Project.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @return Project
     */
    getProject(accountId, projectId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetProject(_response);
        });
    }
    processGetProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Project.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @return removed the Project
     */
    deleteProject(accountId, projectId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteProject(_response);
        });
    }
    processDeleteProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Project.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param body (optional)
     * @return Project
     */
    updateProject(accountId, projectId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateProject(_response);
        });
    }
    processUpdateProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Project.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @return array for  Version Items
     */
    getVersions(accountId, projectId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVersions(_response);
        });
    }
    processGetVersions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Version.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param body (optional)
     * @return a Project
     */
    createVersion(accountId, projectId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateVersion(_response);
        });
    }
    processCreateVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Version.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return Version
     */
    getVersion(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVersion(_response);
        });
    }
    processGetVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Version.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param versionId versionId
     * @return removed the Version
     */
    deleteVersion(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteVersion(_response);
        });
    }
    processDeleteVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Version.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param versionId versionId
     * @param body (optional)
     * @return Project
     */
    updateVersion(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersion(_response);
        });
    }
    processUpdateVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Version.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return result
     */
    cloneVersion(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/clone";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCloneVersion(_response);
        });
    }
    processCloneVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = ImportClone.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @return array for  Channel Items
     */
    getChannels(accountId, projectId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetChannels(_response);
        });
    }
    processGetChannels(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Channel.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param body (optional)
     * @return a Channel
     */
    createChannel(accountId, projectId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateChannel(_response);
        });
    }
    processCreateChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Channel.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channelId channelId
     * @return Channel
     */
    getChannel(accountId, projectId, channelId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channelId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetChannel(_response);
        });
    }
    processGetChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Channel.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param channelId channelId
     * @return removed the Channel
     */
    deleteChannel(accountId, projectId, channelId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channelId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteChannel(_response);
        });
    }
    processDeleteChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Channel.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param channelId channelId
     * @param body (optional)
     * @return Project
     */
    updateChannel(accountId, projectId, channelId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channelId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateChannel(_response);
        });
    }
    processUpdateChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Channel.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return array for MicroIntend
     */
    getMicroIntends(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-intends";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMicroIntends(_response);
        });
    }
    processGetMicroIntends(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MicroIntend.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param body (optional)
     * @return a MicroIntend
     */
    createMicroIntend(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-intends";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMicroIntend(_response);
        });
    }
    processCreateMicroIntend(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroIntend.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return array for Json Schema
     */
    getJsonSchemas(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/json-schema";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetJsonSchemas(_response);
        });
    }
    processGetJsonSchemas(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(JSONSchema.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param body (optional)
     * @return JSONSchema
     */
    createJsonSchema(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/json-schema";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateJsonSchema(_response);
        });
    }
    processCreateJsonSchema(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSONSchema.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param schemaId schemaId
     * @return JSONSchema
     */
    getJsonSchema(accountId, projectId, versionId, schemaId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/json-schema/{schemaId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (schemaId === undefined || schemaId === null)
            throw new Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetJsonSchema(_response);
        });
    }
    processGetJsonSchema(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSONSchema.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param schemaId schemaId
     * @param body (optional)
     * @return JSONSchema
     */
    updateJsonSchema(accountId, projectId, versionId, schemaId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/json-schema/{schemaId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (schemaId === undefined || schemaId === null)
            throw new Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateJsonSchema(_response);
        });
    }
    processUpdateJsonSchema(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSONSchema.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param microIntendId microIntendId
     * @return MicroIntend
     */
    getMicroIntend(accountId, projectId, versionId, microIntendId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-intends/{microIntendId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (microIntendId === undefined || microIntendId === null)
            throw new Error("The parameter 'microIntendId' must be defined.");
        url_ = url_.replace("{microIntendId}", encodeURIComponent("" + microIntendId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMicroIntend(_response);
        });
    }
    processGetMicroIntend(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroIntend.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param microIntendId microIntendId
     * @param body (optional)
     * @return MicroIntend
     */
    updateMicroIntend(accountId, projectId, versionId, microIntendId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-intends/{microIntendId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (microIntendId === undefined || microIntendId === null)
            throw new Error("The parameter 'microIntendId' must be defined.");
        url_ = url_.replace("{microIntendId}", encodeURIComponent("" + microIntendId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateMicroIntend(_response);
        });
    }
    processUpdateMicroIntend(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroIntend.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param microIntendId microIntendId
     * @return removed the MicroIntend
     */
    deleteMicroIntend(accountId, projectId, versionId, microIntendId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-intends/{microIntendId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (microIntendId === undefined || microIntendId === null)
            throw new Error("The parameter 'microIntendId' must be defined.");
        url_ = url_.replace("{microIntendId}", encodeURIComponent("" + microIntendId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteMicroIntend(_response);
        });
    }
    processDeleteMicroIntend(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroIntend.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return array for MicroMacro
     */
    getMicroMacros(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-macro";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMicroMacros(_response);
        });
    }
    processGetMicroMacros(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MicroMacro.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param body (optional)
     * @return a MicroIntend
     */
    createMicroMacro(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-macro";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMicroMacro(_response);
        });
    }
    processCreateMicroMacro(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroIntend.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param microMacroId microMacroId
     * @return MicroMacro
     */
    getMicroMacro(accountId, projectId, versionId, microMacroId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-macro/{microMacroId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (microMacroId === undefined || microMacroId === null)
            throw new Error("The parameter 'microMacroId' must be defined.");
        url_ = url_.replace("{microMacroId}", encodeURIComponent("" + microMacroId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMicroMacro(_response);
        });
    }
    processGetMicroMacro(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroMacro.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param microMacroId microMacroId
     * @return MicroMacro
     */
    updateMicroMacro(accountId, projectId, versionId, microMacroId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-macro/{microMacroId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (microMacroId === undefined || microMacroId === null)
            throw new Error("The parameter 'microMacroId' must be defined.");
        url_ = url_.replace("{microMacroId}", encodeURIComponent("" + microMacroId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateMicroMacro(_response);
        });
    }
    processUpdateMicroMacro(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroMacro.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param microMacroId microMacroId
     * @return removed the MicroMacro
     */
    deleteMicroMacro(accountId, projectId, versionId, microMacroId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/micro-macro/{microMacroId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (microMacroId === undefined || microMacroId === null)
            throw new Error("The parameter 'microMacroId' must be defined.");
        url_ = url_.replace("{microMacroId}", encodeURIComponent("" + microMacroId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteMicroMacro(_response);
        });
    }
    processDeleteMicroMacro(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MicroMacro.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return array for QueueItems
     */
    getJobs(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning-job";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetJobs(_response);
        });
    }
    processGetJobs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(QueueItem.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return a QueueItem
     */
    createJob(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning-job";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateJob(_response);
        });
    }
    processCreateJob(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = QueueItem.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param jobId jobId
     * @return QueueItem
     */
    getJob(accountId, projectId, versionId, jobId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning/jobId/{jobId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetJob(_response);
        });
    }
    processGetJob(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = QueueItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param jobId jobId
     * @return removed the Job
     */
    deleteJob(accountId, projectId, versionId, jobId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning/jobId/{jobId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteJob(_response);
        });
    }
    processDeleteJob(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = QueueItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param b2bPartnerId b2bPartnerId
     * @return array for Cucumber Features Tags
     */
    getCucumberFeaturesTags(b2bPartnerId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/{b2bPartnerId}/cucumber-features/tags";
        if (b2bPartnerId === undefined || b2bPartnerId === null)
            throw new Error("The parameter 'b2bPartnerId' must be defined.");
        url_ = url_.replace("{b2bPartnerId}", encodeURIComponent("" + b2bPartnerId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCucumberFeaturesTags(_response);
        });
    }
    processGetCucumberFeaturesTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param b2bPartnerId b2bPartnerId
     * @return array for Cucumber Features
     */
    getCucumberFeatures(b2bPartnerId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/{b2bPartnerId}/cucumber-features";
        if (b2bPartnerId === undefined || b2bPartnerId === null)
            throw new Error("The parameter 'b2bPartnerId' must be defined.");
        url_ = url_.replace("{b2bPartnerId}", encodeURIComponent("" + b2bPartnerId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCucumberFeatures(_response);
        });
    }
    processGetCucumberFeatures(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CucumberFeature.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param b2bPartnerId b2bPartnerId
     * @param body (optional)
     * @return a Cucumber Features
     */
    createCucumberFeature(b2bPartnerId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/{b2bPartnerId}/cucumber-features";
        if (b2bPartnerId === undefined || b2bPartnerId === null)
            throw new Error("The parameter 'b2bPartnerId' must be defined.");
        url_ = url_.replace("{b2bPartnerId}", encodeURIComponent("" + b2bPartnerId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateCucumberFeature(_response);
        });
    }
    processCreateCucumberFeature(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = CucumberFeature.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param version version
     * @return array for MachineLearningModels
     */
    getMachineLearningModels(accountId, projectId, version, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{version}/machine-learning-models";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMachineLearningModels(_response);
        });
    }
    processGetMachineLearningModels(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MlModel.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param version version
     * @param body (optional)
     * @return a MachineLearningModel
     */
    createMachineLearningModel(accountId, projectId, version, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{version}/machine-learning-models";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMachineLearningModel(_response);
        });
    }
    processCreateMachineLearningModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MlModel.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param versionId version
     * @param machineLearningModelId MachineLearningModelId
     * @return MachineLearningModel
     */
    getMachineLearningModel(accountId, projectId, versionId, machineLearningModelId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning-models/{machineLearningModelId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (machineLearningModelId === undefined || machineLearningModelId === null)
            throw new Error("The parameter 'machineLearningModelId' must be defined.");
        url_ = url_.replace("{machineLearningModelId}", encodeURIComponent("" + machineLearningModelId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMachineLearningModel(_response);
        });
    }
    processGetMachineLearningModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MlModel.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param versionId version
     * @param machineLearningModelId MachineLearningModelId
     * @return MachineLearningModel
     */
    deleteMachineLearningModel(accountId, projectId, versionId, machineLearningModelId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning-models/{machineLearningModelId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (machineLearningModelId === undefined || machineLearningModelId === null)
            throw new Error("The parameter 'machineLearningModelId' must be defined.");
        url_ = url_.replace("{machineLearningModelId}", encodeURIComponent("" + machineLearningModelId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteMachineLearningModel(_response);
        });
    }
    processDeleteMachineLearningModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MlModel.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountId
     * @param projectId projectId
     * @param versionId version
     * @param machineLearningModelId MachineLearningModelId
     * @param body (optional)
     * @return MachineLearningModel
     */
    updateMachineLearningModel(accountId, projectId, versionId, machineLearningModelId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/machine-learning-models/{machineLearningModelId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (machineLearningModelId === undefined || machineLearningModelId === null)
            throw new Error("The parameter 'machineLearningModelId' must be defined.");
        url_ = url_.replace("{machineLearningModelId}", encodeURIComponent("" + machineLearningModelId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateMachineLearningModel(_response);
        });
    }
    processUpdateMachineLearningModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = MlModel.fromJS(resultData200);
            return result200;
        }
        else if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = MlModel.fromJS(resultData201);
            return result201;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ValidationErrors.fromJS(resultData400);
            return throwException("valication error", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param b2bPartnerId b2bPartnerId
     * @param cucumberFeatureId CucumberFeatureId
     * @return Cucumber Features
     */
    getCucumberFeature(b2bPartnerId, cucumberFeatureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/{b2bPartnerId}/cucumber-features/{CucumberFeatureId}";
        if (b2bPartnerId === undefined || b2bPartnerId === null)
            throw new Error("The parameter 'b2bPartnerId' must be defined.");
        url_ = url_.replace("{b2bPartnerId}", encodeURIComponent("" + b2bPartnerId));
        if (cucumberFeatureId === undefined || cucumberFeatureId === null)
            throw new Error("The parameter 'cucumberFeatureId' must be defined.");
        url_ = url_.replace("{CucumberFeatureId}", encodeURIComponent("" + cucumberFeatureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCucumberFeature(_response);
        });
    }
    processGetCucumberFeature(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = CucumberFeature.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param b2bPartnerId b2bPartnerId
     * @param cucumberFeatureId CucumberFeatureId
     * @param body (optional)
     * @return Cucumber Features
     */
    updateCucumberFeature(b2bPartnerId, cucumberFeatureId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/{b2bPartnerId}/cucumber-features/{CucumberFeatureId}";
        if (b2bPartnerId === undefined || b2bPartnerId === null)
            throw new Error("The parameter 'b2bPartnerId' must be defined.");
        url_ = url_.replace("{b2bPartnerId}", encodeURIComponent("" + b2bPartnerId));
        if (cucumberFeatureId === undefined || cucumberFeatureId === null)
            throw new Error("The parameter 'cucumberFeatureId' must be defined.");
        url_ = url_.replace("{CucumberFeatureId}", encodeURIComponent("" + cucumberFeatureId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateCucumberFeature(_response);
        });
    }
    processUpdateCucumberFeature(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = CucumberFeature.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param b2bPartnerId b2bPartnerId
     * @param cucumberFeatureId CucumberFeatureId
     * @return the removed Cucumber Features
     */
    deleteCucumberFeature(b2bPartnerId, cucumberFeatureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/{b2bPartnerId}/cucumber-features/{CucumberFeatureId}";
        if (b2bPartnerId === undefined || b2bPartnerId === null)
            throw new Error("The parameter 'b2bPartnerId' must be defined.");
        url_ = url_.replace("{b2bPartnerId}", encodeURIComponent("" + b2bPartnerId));
        if (cucumberFeatureId === undefined || cucumberFeatureId === null)
            throw new Error("The parameter 'cucumberFeatureId' must be defined.");
        url_ = url_.replace("{CucumberFeatureId}", encodeURIComponent("" + cucumberFeatureId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteCucumberFeature(_response);
        });
    }
    processDeleteCucumberFeature(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = CucumberFeature.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channelId channelId
     * @param eventId eventId
     * @return JSCodeRuntimeLog
     */
    getRuntimeLog(accountId, projectId, channelId, eventId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channelId}/runtimelogs/{eventId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRuntimeLog(_response);
        });
    }
    processGetRuntimeLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSCodeRuntimeLog.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param nodeitemId nodeitemId
     * @return JsCode
     */
    getTrustedDeveloperJscode(accountId, projectId, versionId, nodeitemId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/node-items/{nodeitemId}/trusted-developer-jscode";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (nodeitemId === undefined || nodeitemId === null)
            throw new Error("The parameter 'nodeitemId' must be defined.");
        url_ = url_.replace("{nodeitemId}", encodeURIComponent("" + nodeitemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetTrustedDeveloperJscode(_response);
        });
    }
    processGetTrustedDeveloperJscode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSCode.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param nodeitemId nodeitemId
     * @param body (optional)
     * @return JsCode
     */
    updateTrustedDeveloperJscode(accountId, projectId, versionId, nodeitemId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/node-items/{nodeitemId}/trusted-developer-jscode";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (nodeitemId === undefined || nodeitemId === null)
            throw new Error("The parameter 'nodeitemId' must be defined.");
        url_ = url_.replace("{nodeitemId}", encodeURIComponent("" + nodeitemId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateTrustedDeveloperJscode(_response);
        });
    }
    processUpdateTrustedDeveloperJscode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSCode.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @param nodeitemId nodeitemId
     * @param body (optional)
     * @return JsCode
     */
    createTrustedDeveloperJscode(accountId, projectId, versionId, nodeitemId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/node-items/{nodeitemId}/trusted-developer-jscode";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (nodeitemId === undefined || nodeitemId === null)
            throw new Error("The parameter 'nodeitemId' must be defined.");
        url_ = url_.replace("{nodeitemId}", encodeURIComponent("" + nodeitemId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateTrustedDeveloperJscode(_response);
        });
    }
    processCreateTrustedDeveloperJscode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSCode.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @return array for  Node Items
     */
    getNodeItems(accountId, projectId, version, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-items";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNodeItems(_response);
        });
    }
    processGetNodeItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NodeItem.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param body (optional)
     * @return a NodeItem
     */
    createNodeItem(accountId, projectId, version, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-items";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateNodeItem(_response);
        });
    }
    processCreateNodeItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param nodeItemId NodeItemId
     * @return NodeItem
     */
    getNodeItem(accountId, projectId, version, nodeItemId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-items/{NodeItemId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNodeItem(_response);
        });
    }
    processGetNodeItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param nodeItemId NodeItemId
     * @return NodeItem
     */
    deleteNodeItem(accountId, projectId, version, nodeItemId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-items/{NodeItemId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteNodeItem(_response);
        });
    }
    processDeleteNodeItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param nodeItemId NodeItemId
     * @param body (optional)
     * @return NodeItem
     */
    updateNodeItem(accountId, projectId, version, nodeItemId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-items/{NodeItemId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateNodeItem(_response);
        });
    }
    processUpdateNodeItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = NodeItem.fromJS(resultData201);
            return result201;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ValidationErrors.fromJS(resultData400);
            return throwException("valication error", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param nodeItemId NodeItemId
     * @return NodeItem
     */
    moveNodeItem(accountId, projectId, version, nodeItemId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-items/{NodeItemId}/move";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processMoveNodeItem(_response);
        });
    }
    processMoveNodeItem(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @return openapi.json
     */
    getOpenApiJson(accountId, projectId, version, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{version}/openapi.json";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetOpenApiJson(_response);
        });
    }
    processGetOpenApiJson(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channelId channelId
     * @return openapi.json
     */
    getChannelOpenApiJson(accountId, projectId, channelId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channelId}/openapi.json";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetChannelOpenApiJson(_response);
        });
    }
    processGetChannelOpenApiJson(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channel channel
     * @return array for  Node Items
     */
    getNodeItemsByChannel(accountId, projectId, channel, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channel}/node-items";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined.");
        url_ = url_.replace("{channel}", encodeURIComponent("" + channel));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNodeItemsByChannel(_response);
        });
    }
    processGetNodeItemsByChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NodeItem.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channel channel
     * @param body (optional)
     * @return a NodeItem
     */
    createNodeItemByChannel(accountId, projectId, channel, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channel}/node-items";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined.");
        url_ = url_.replace("{channel}", encodeURIComponent("" + channel));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateNodeItemByChannel(_response);
        });
    }
    processCreateNodeItemByChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channel channel
     * @param nodeItemId NodeItemId
     * @return NodeItem
     */
    getNodeItemByChannel(accountId, projectId, channel, nodeItemId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channel}/node-items/{NodeItemId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined.");
        url_ = url_.replace("{channel}", encodeURIComponent("" + channel));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNodeItemByChannel(_response);
        });
    }
    processGetNodeItemByChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channel channel
     * @param nodeItemId NodeItemId
     * @return NodeItem
     */
    deleteNodeItemByChannel(accountId, projectId, channel, nodeItemId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channel}/node-items/{NodeItemId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined.");
        url_ = url_.replace("{channel}", encodeURIComponent("" + channel));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteNodeItemByChannel(_response);
        });
    }
    processDeleteNodeItemByChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param channel channel
     * @param nodeItemId NodeItemId
     * @param body (optional)
     * @return NodeItem
     */
    updateNodeItemByChannel(accountId, projectId, channel, nodeItemId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/channels/{channel}/node-items/{NodeItemId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (channel === undefined || channel === null)
            throw new Error("The parameter 'channel' must be defined.");
        url_ = url_.replace("{channel}", encodeURIComponent("" + channel));
        if (nodeItemId === undefined || nodeItemId === null)
            throw new Error("The parameter 'nodeItemId' must be defined.");
        url_ = url_.replace("{NodeItemId}", encodeURIComponent("" + nodeItemId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateNodeItemByChannel(_response);
        });
    }
    processUpdateNodeItemByChannel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItem.fromJS(resultData200);
            return result200;
        }
        else if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = NodeItem.fromJS(resultData201);
            return result201;
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = ValidationErrors.fromJS(resultData400);
            return throwException("valication error", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @return array for  NodeItemFunctionTemplates
     */
    getNodeItemFunctionTemplates(accountId, projectId, version, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-item-function-templates";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNodeItemFunctionTemplates(_response);
        });
    }
    processGetNodeItemFunctionTemplates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NodeItemFunctionTemplate.fromJS(item));
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param body (optional)
     * @return a NodeItemFunctionTemplate
     */
    createNodeItemFunctionTemplate(accountId, projectId, version, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-item-function-templates";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateNodeItemFunctionTemplate(_response);
        });
    }
    processCreateNodeItemFunctionTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItemFunctionTemplate.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param nodeItemFunctionTemplateId NodeItemFunctionTemplateId
     * @return NodeItemFunctionTemplate
     */
    getNodeItemFunctionTemplate(accountId, projectId, version, nodeItemFunctionTemplateId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-item-function-templates/{NodeItemFunctionTemplateId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nodeItemFunctionTemplateId === undefined || nodeItemFunctionTemplateId === null)
            throw new Error("The parameter 'nodeItemFunctionTemplateId' must be defined.");
        url_ = url_.replace("{NodeItemFunctionTemplateId}", encodeURIComponent("" + nodeItemFunctionTemplateId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNodeItemFunctionTemplate(_response);
        });
    }
    processGetNodeItemFunctionTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItemFunctionTemplate.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param version version
     * @param nodeItemFunctionTemplateId NodeItemFunctionTemplateId
     * @param body (optional)
     * @return NodeItemFunctionTemplate
     */
    updateNodeItemFunctionTemplate(accountId, projectId, version, nodeItemFunctionTemplateId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/version/{version}/node-item-function-templates/{NodeItemFunctionTemplateId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nodeItemFunctionTemplateId === undefined || nodeItemFunctionTemplateId === null)
            throw new Error("The parameter 'nodeItemFunctionTemplateId' must be defined.");
        url_ = url_.replace("{NodeItemFunctionTemplateId}", encodeURIComponent("" + nodeItemFunctionTemplateId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateNodeItemFunctionTemplate(_response);
        });
    }
    processUpdateNodeItemFunctionTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = NodeItemFunctionTemplate.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return a NLP Respone
     */
    runNlp(accountId, projectId, versionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/nlp";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRunNlp(_response);
        });
    }
    processRunNlp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Nlp.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = Nlp.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param versionId versionId
     * @return zip file
     */
    exportVersion(accountId, projectId, versionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/versions/{versionId}/export";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/zip"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processExportVersion(_response);
        });
    }
    processExportVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param accountId accountID
     * @param projectId projectId
     * @param zip (optional)
     * @return import analyse account
     */
    importVersion(accountId, projectId, zip, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/accounts/{accountId}/projects/{projectId}/import-version";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (zip === null || zip === undefined)
            throw new Error("The parameter 'zip' cannot be null.");
        else
            content_.append("zip", zip.data, zip.fileName ? zip.fileName : "zip");
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processImportVersion(_response);
        });
    }
    processImportVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = ImportClone.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return array of facts
     */
    facts(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/facts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processFacts(_response);
        });
    }
    processFacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Anonymous.fromJS(resultData200);
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param image (optional)
     * @return image information
     */
    upload_image(image, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/image/upload";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpload_image(_response);
        });
    }
    processUpload_image(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Image.fromJS(resultData200);
            return result200;
        }
        else {
            const _responseText = response.data;
            let resultdefault = null;
            let resultDatadefault = _responseText;
            resultdefault = ValidationErrors.fromJS(resultDatadefault);
            return throwException("valication error", status, _responseText, _headers, resultdefault);
        }
    }
}
exports.Client = Client;
class ImportClone {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.newVersionId = _data["newVersionId"];
            if (Array.isArray(_data["results"])) {
                this.results = [];
                for (let item of _data["results"])
                    this.results.push(Results.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ImportClone();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["newVersionId"] = this.newVersionId;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}
exports.ImportClone = ImportClone;
class Config {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.uSER_POOL_ID = _data["USER_POOL_ID"];
            this.uSER_POOL_CLIENT_ID = _data["USER_POOL_CLIENT_ID"];
            this.uSER_POOL_DOMAIN = _data["USER_POOL_DOMAIN"];
            this.aI_EVENT_API_BASE_URL = _data["AI_EVENT_API_BASE_URL"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Config();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["USER_POOL_ID"] = this.uSER_POOL_ID;
        data["USER_POOL_CLIENT_ID"] = this.uSER_POOL_CLIENT_ID;
        data["USER_POOL_DOMAIN"] = this.uSER_POOL_DOMAIN;
        data["AI_EVENT_API_BASE_URL"] = this.aI_EVENT_API_BASE_URL;
        return data;
    }
}
exports.Config = Config;
class NlpProcessor {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.enabled = true;
            this.scope = "notset";
            this.minTokensize = 2;
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : true;
            this.type = _data["type"];
            this.b2bPartnerId = _data["b2bPartnerId"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.stopwords = _data["stopwords"];
            this.minval = _data["minval"];
            this.maxval = _data["maxval"];
            this.nodeclass = _data["nodeclass"];
            if (Array.isArray(_data["stopwordList"])) {
                this.stopwordList = [];
                for (let item of _data["stopwordList"])
                    this.stopwordList.push(item);
            }
            this.extensionMap = _data["extensionMap"];
            if (Array.isArray(_data["trainingdata"])) {
                this.trainingdata = [];
                for (let item of _data["trainingdata"])
                    this.trainingdata.push(item);
            }
            this.dbfield = _data["dbfield"];
            this.scope = _data["scope"] !== undefined ? _data["scope"] : "notset";
            this.minTokensize = _data["minTokensize"] !== undefined ? _data["minTokensize"] : 2;
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NlpProcessor();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["type"] = this.type;
        data["b2bPartnerId"] = this.b2bPartnerId;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["stopwords"] = this.stopwords;
        data["minval"] = this.minval;
        data["maxval"] = this.maxval;
        data["nodeclass"] = this.nodeclass;
        if (Array.isArray(this.stopwordList)) {
            data["stopwordList"] = [];
            for (let item of this.stopwordList)
                data["stopwordList"].push(item);
        }
        data["extensionMap"] = this.extensionMap;
        if (Array.isArray(this.trainingdata)) {
            data["trainingdata"] = [];
            for (let item of this.trainingdata)
                data["trainingdata"].push(item);
        }
        data["dbfield"] = this.dbfield;
        data["scope"] = this.scope;
        data["minTokensize"] = this.minTokensize;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.NlpProcessor = NlpProcessor;
class MicroIntend {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.intendStateKey = "richtig/falsch";
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.userComment = _data["userComment"];
            if (Array.isArray(_data["tagsPositive"])) {
                this.tagsPositive = [];
                for (let item of _data["tagsPositive"])
                    this.tagsPositive.push(item);
            }
            if (Array.isArray(_data["trainingsetsPositiveList"])) {
                this.trainingsetsPositiveList = [];
                for (let item of _data["trainingsetsPositiveList"])
                    this.trainingsetsPositiveList.push(item);
            }
            this.trainedNodeitemPositive = _data["trainedNodeitemPositive"];
            if (Array.isArray(_data["tagsNegative"])) {
                this.tagsNegative = [];
                for (let item of _data["tagsNegative"])
                    this.tagsNegative.push(item);
            }
            if (Array.isArray(_data["trainingsetsNegativeList"])) {
                this.trainingsetsNegativeList = [];
                for (let item of _data["trainingsetsNegativeList"])
                    this.trainingsetsNegativeList.push(item);
            }
            this.trainedNodeitemNegative = _data["trainedNodeitemNegative"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [];
                for (let item of _data["entities"])
                    this.entities.push(Entities.fromJS(item));
            }
            this.intendStates = _data["intendStates"];
            this.intendStateKey = _data["intendStateKey"] !== undefined ? _data["intendStateKey"] : "richtig/falsch";
            this.refId = _data["refId"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MicroIntend();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userComment"] = this.userComment;
        if (Array.isArray(this.tagsPositive)) {
            data["tagsPositive"] = [];
            for (let item of this.tagsPositive)
                data["tagsPositive"].push(item);
        }
        if (Array.isArray(this.trainingsetsPositiveList)) {
            data["trainingsetsPositiveList"] = [];
            for (let item of this.trainingsetsPositiveList)
                data["trainingsetsPositiveList"].push(item);
        }
        data["trainedNodeitemPositive"] = this.trainedNodeitemPositive;
        if (Array.isArray(this.tagsNegative)) {
            data["tagsNegative"] = [];
            for (let item of this.tagsNegative)
                data["tagsNegative"].push(item);
        }
        if (Array.isArray(this.trainingsetsNegativeList)) {
            data["trainingsetsNegativeList"] = [];
            for (let item of this.trainingsetsNegativeList)
                data["trainingsetsNegativeList"].push(item);
        }
        data["trainedNodeitemNegative"] = this.trainedNodeitemNegative;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["intendStates"] = this.intendStates;
        data["intendStateKey"] = this.intendStateKey;
        data["refId"] = this.refId;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.MicroIntend = MicroIntend;
class JSONSchema {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["indexes"])) {
                this.indexes = [];
                for (let item of _data["indexes"])
                    this.indexes.push(item);
            }
            this.jsonSchema = _data["jsonSchema"];
            this.uiSchema = _data["uiSchema"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            if (Array.isArray(_data["state"])) {
                this.state = [];
                for (let item of _data["state"])
                    this.state.push(item);
            }
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new JSONSchema();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.indexes)) {
            data["indexes"] = [];
            for (let item of this.indexes)
                data["indexes"].push(item);
        }
        data["jsonSchema"] = this.jsonSchema;
        data["uiSchema"] = this.uiSchema;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        if (Array.isArray(this.state)) {
            data["state"] = [];
            for (let item of this.state)
                data["state"].push(item);
        }
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.JSONSchema = JSONSchema;
class JSCode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refId = _data["refId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.jsCode = _data["jsCode"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            if (Array.isArray(_data["executionScope"])) {
                this.executionScope = [];
                for (let item of _data["executionScope"])
                    this.executionScope.push(item);
            }
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new JSCode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["jsCode"] = this.jsCode;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        if (Array.isArray(this.executionScope)) {
            data["executionScope"] = [];
            for (let item of this.executionScope)
                data["executionScope"].push(item);
        }
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.JSCode = JSCode;
class MicroMacro {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.b2bPartnerId = _data["b2bPartnerId"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.trainedNodeitem = _data["trainedNodeitem"];
            if (Array.isArray(_data["microIntendConfig"])) {
                this.microIntendConfig = [];
                for (let item of _data["microIntendConfig"])
                    this.microIntendConfig.push(item);
            }
            this.nodeGroupSource = _data["nodeGroupSource"];
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MicroMacro();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["b2bPartnerId"] = this.b2bPartnerId;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["trainedNodeitem"] = this.trainedNodeitem;
        if (Array.isArray(this.microIntendConfig)) {
            data["microIntendConfig"] = [];
            for (let item of this.microIntendConfig)
                data["microIntendConfig"].push(item);
        }
        data["nodeGroupSource"] = this.nodeGroupSource;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.MicroMacro = MicroMacro;
class CucumberFeature {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.name = _data["name"];
            this.feature = _data["feature"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CucumberFeature();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["name"] = this.name;
        data["feature"] = this.feature;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.CucumberFeature = CucumberFeature;
class Fact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.b2bPartnerId = _data["b2bPartnerId"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [];
                for (let item of _data["inputs"])
                    this.inputs.push(Inputs.fromJS(item));
            }
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [];
                for (let item of _data["outputs"])
                    this.outputs.push(Outputs.fromJS(item));
            }
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Fact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["b2bPartnerId"] = this.b2bPartnerId;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item.toJSON());
        }
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.Fact = Fact;
class NodeItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.isStoryNode = false;
            this.allowHistory = true;
        }
    }
    init(_data) {
        if (_data) {
            this.refId = _data["refId"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.nickname = _data["nickname"];
            if (Array.isArray(_data["displayedNickname"])) {
                this.displayedNickname = [];
                for (let item of _data["displayedNickname"])
                    this.displayedNickname.push(DisplayedNickname.fromJS(item));
            }
            this.isStoryNode = _data["isStoryNode"] !== undefined ? _data["isStoryNode"] : false;
            if (Array.isArray(_data["aiEventActivation"])) {
                this.aiEventActivation = [];
                for (let item of _data["aiEventActivation"])
                    this.aiEventActivation.push(item);
            }
            this.allowHistory = _data["allowHistory"] !== undefined ? _data["allowHistory"] : true;
            if (Array.isArray(_data["machineHead"])) {
                this.machineHead = [];
                for (let item of _data["machineHead"])
                    this.machineHead.push(item);
            }
            this.storyOptions = _data["storyOptions"] ? StoryOptions.fromJS(_data["storyOptions"]) : undefined;
            if (Array.isArray(_data["initTransitions"])) {
                this.initTransitions = [];
                for (let item of _data["initTransitions"])
                    this.initTransitions.push(InitTransitions.fromJS(item));
            }
            if (Array.isArray(_data["globalTransitions"])) {
                this.globalTransitions = [];
                for (let item of _data["globalTransitions"])
                    this.globalTransitions.push(GlobalTransitions.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [];
                for (let item of _data["states"])
                    this.states.push(States.fromJS(item));
            }
            this.function = _data["function"] ? Function.fromJS(_data["function"]) : undefined;
            this.guiOptions = _data["guiOptions"] ? GuiOptions.fromJS(_data["guiOptions"]) : undefined;
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NodeItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["nickname"] = this.nickname;
        if (Array.isArray(this.displayedNickname)) {
            data["displayedNickname"] = [];
            for (let item of this.displayedNickname)
                data["displayedNickname"].push(item.toJSON());
        }
        data["isStoryNode"] = this.isStoryNode;
        if (Array.isArray(this.aiEventActivation)) {
            data["aiEventActivation"] = [];
            for (let item of this.aiEventActivation)
                data["aiEventActivation"].push(item);
        }
        data["allowHistory"] = this.allowHistory;
        if (Array.isArray(this.machineHead)) {
            data["machineHead"] = [];
            for (let item of this.machineHead)
                data["machineHead"].push(item);
        }
        data["storyOptions"] = this.storyOptions ? this.storyOptions.toJSON() : undefined;
        if (Array.isArray(this.initTransitions)) {
            data["initTransitions"] = [];
            for (let item of this.initTransitions)
                data["initTransitions"].push(item.toJSON());
        }
        if (Array.isArray(this.globalTransitions)) {
            data["globalTransitions"] = [];
            for (let item of this.globalTransitions)
                data["globalTransitions"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        data["function"] = this.function ? this.function.toJSON() : undefined;
        data["guiOptions"] = this.guiOptions ? this.guiOptions.toJSON() : undefined;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.NodeItem = NodeItem;
class NodeItemGuiPosition {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.x = 250;
            this.y = 250;
            this.colapsed = true;
        }
    }
    init(_data) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : 250;
            this.y = _data["y"] !== undefined ? _data["y"] : 250;
            this.colapsed = _data["colapsed"] !== undefined ? _data["colapsed"] : true;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NodeItemGuiPosition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["colapsed"] = this.colapsed;
        return data;
    }
}
exports.NodeItemGuiPosition = NodeItemGuiPosition;
class Account {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.logo = _data["logo"];
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["logo"] = this.logo;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.Account = Account;
class Project {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.logo = _data["logo"];
            this.account = _data["account"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["logo"] = this.logo;
        data["account"] = this.account;
        data["_id"] = this._id;
        return data;
    }
}
exports.Project = Project;
class Version {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.logo = _data["logo"];
            this.account = _data["account"];
            if (Array.isArray(_data["touchPoints"])) {
                this.touchPoints = [];
                for (let item of _data["touchPoints"])
                    this.touchPoints.push(TouchPoints.fromJS(item));
            }
            this.project = _data["project"];
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["logo"] = this.logo;
        data["account"] = this.account;
        if (Array.isArray(this.touchPoints)) {
            data["touchPoints"] = [];
            for (let item of this.touchPoints)
                data["touchPoints"].push(item.toJSON());
        }
        data["project"] = this.project;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.Version = Version;
class Channel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.logo = _data["logo"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.versionPointer = _data["versionPointer"];
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Channel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["logo"] = this.logo;
        data["account"] = this.account;
        data["project"] = this.project;
        data["versionPointer"] = this.versionPointer;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.Channel = Channel;
class NodeItemFunctionTemplate {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.b2bPartnerId = _data["b2bPartnerId"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.refId = _data["refId"];
            this.version = _data["version"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.output = _data["output"];
            this.parms = _data["parms"];
            this.substory = _data["substory"] ? Substory.fromJS(_data["substory"]) : undefined;
            this.botFunction = _data["botFunction"] ? BotFunction.fromJS(_data["botFunction"]) : undefined;
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NodeItemFunctionTemplate();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["b2bPartnerId"] = this.b2bPartnerId;
        data["account"] = this.account;
        data["project"] = this.project;
        data["refId"] = this.refId;
        data["version"] = this.version;
        data["name"] = this.name;
        data["description"] = this.description;
        data["output"] = this.output;
        data["parms"] = this.parms;
        data["substory"] = this.substory ? this.substory.toJSON() : undefined;
        data["botFunction"] = this.botFunction ? this.botFunction.toJSON() : undefined;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.NodeItemFunctionTemplate = NodeItemFunctionTemplate;
class QueueItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            if (Array.isArray(_data["log"])) {
                this.log = [];
                for (let item of _data["log"])
                    this.log.push(item);
            }
            this.jobName = _data["jobName"];
            this.data = _data["data"];
            this.healthCheck = _data["healthCheck"] ? new Date(_data["healthCheck"].toString()) : undefined;
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueueItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        if (Array.isArray(this.log)) {
            data["log"] = [];
            for (let item of this.log)
                data["log"].push(item);
        }
        data["jobName"] = this.jobName;
        data["data"] = this.data;
        data["healthCheck"] = this.healthCheck ? this.healthCheck.toISOString() : undefined;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.QueueItem = QueueItem;
class Nlp {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.__v = _data["__v"];
            this._id = _data["_id"];
            this.account = _data["account"];
            this.classification = _data["classification"] ? Classification.fromJS(_data["classification"]) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            if (Array.isArray(_data["features"])) {
                this.features = [];
                for (let item of _data["features"])
                    this.features.push(item);
            }
            this.input = _data["input"];
            this.project = _data["project"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Nlp();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["__v"] = this.__v;
        data["_id"] = this._id;
        data["account"] = this.account;
        data["classification"] = this.classification ? this.classification.toJSON() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["input"] = this.input;
        data["project"] = this.project;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["version"] = this.version;
        return data;
    }
}
exports.Nlp = Nlp;
class Image {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}
exports.Image = Image;
class MlModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.active = true;
            this.logicEngine = MlModelLogicEngine.AgileNeuroDescider;
        }
    }
    init(_data) {
        if (_data) {
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.active = _data["active"] !== undefined ? _data["active"] : true;
            this.dictionary = _data["dictionary"] ? Dictionary.fromJS(_data["dictionary"]) : undefined;
            this.customData = _data["customData"];
            this.logicEngine = _data["logicEngine"] !== undefined ? _data["logicEngine"] : MlModelLogicEngine.AgileNeuroDescider;
            this.refId = _data["refId"];
            this.modelStringyfiedJSON = _data["modelStringyfiedJSON"];
            if (Array.isArray(_data["modelDownloadUrls"])) {
                this.modelDownloadUrls = [];
                for (let item of _data["modelDownloadUrls"])
                    this.modelDownloadUrls.push(ModelDownloadUrls.fromJS(item));
            }
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MlModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["active"] = this.active;
        data["dictionary"] = this.dictionary ? this.dictionary.toJSON() : undefined;
        data["customData"] = this.customData;
        data["logicEngine"] = this.logicEngine;
        data["refId"] = this.refId;
        data["modelStringyfiedJSON"] = this.modelStringyfiedJSON;
        if (Array.isArray(this.modelDownloadUrls)) {
            data["modelDownloadUrls"] = [];
            for (let item of this.modelDownloadUrls)
                data["modelDownloadUrls"].push(item.toJSON());
        }
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.MlModel = MlModel;
class JSCodeRuntimeLog {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.account = _data["account"];
            this.project = _data["project"];
            this.version = _data["version"];
            this.channel = _data["channel"];
            this.event = _data["event"];
            this.owner = _data["owner"];
            this.statusCode = _data["statusCode"];
            this.exception = _data["exception"];
            this.stack = _data["stack"];
            this.logs = _data["logs"] ? Logs.fromJS(_data["logs"]) : undefined;
            this.errorCases = _data["errorCases"] ? ErrorCases.fromJS(_data["errorCases"]) : undefined;
            this._id = _data["_id"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new JSCodeRuntimeLog();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["project"] = this.project;
        data["version"] = this.version;
        data["channel"] = this.channel;
        data["event"] = this.event;
        data["owner"] = this.owner;
        data["statusCode"] = this.statusCode;
        data["exception"] = this.exception;
        data["stack"] = this.stack;
        data["logs"] = this.logs ? this.logs.toJSON() : undefined;
        data["errorCases"] = this.errorCases ? this.errorCases.toJSON() : undefined;
        data["_id"] = this._id;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
exports.JSCodeRuntimeLog = JSCodeRuntimeLog;
class ValidationErrors {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrors();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : undefined;
        return data;
    }
}
exports.ValidationErrors = ValidationErrors;
class Anonymous {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.responseCode = _data["responseCode"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(Fact.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["responseCode"] = this.responseCode;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}
exports.Anonymous = Anonymous;
class Results {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.model = _data["model"];
            this.insertedCount = _data["insertedCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Results();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["insertedCount"] = this.insertedCount;
        return data;
    }
}
exports.Results = Results;
var NlpProcessorType;
(function (NlpProcessorType) {
    NlpProcessorType["Sentence"] = "sentence";
})(NlpProcessorType = exports.NlpProcessorType || (exports.NlpProcessorType = {}));
class Entities {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [];
                for (let item of _data["values"])
                    this.values.push(item);
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Entities();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.Entities = Entities;
var State;
(function (State) {
    State["State"] = "state";
    State["SuggestedOption"] = "suggestedOption";
    State["EventInput"] = "eventInput";
    State["Event"] = "event";
    State["Brick"] = "brick";
})(State = exports.State || (exports.State = {}));
var ExecutionScope;
(function (ExecutionScope) {
    ExecutionScope["NodeItemTrustedDeveloperJSCode"] = "nodeItemTrustedDeveloperJSCode";
})(ExecutionScope = exports.ExecutionScope || (exports.ExecutionScope = {}));
class Inputs {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
            this.name = _data["name"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Inputs();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["name"] = this.name;
        data["_id"] = this._id;
        return data;
    }
}
exports.Inputs = Inputs;
class Outputs {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
            this.name = _data["name"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Outputs();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["name"] = this.name;
        data["_id"] = this._id;
        return data;
    }
}
exports.Outputs = Outputs;
class DisplayedNickname {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tpKey = _data["tpKey"];
            this.tpValue = _data["tpValue"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayedNickname();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tpKey"] = this.tpKey;
        data["tpValue"] = this.tpValue;
        data["_id"] = this._id;
        return data;
    }
}
exports.DisplayedNickname = DisplayedNickname;
class MachineHead {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refId = _data["refId"];
            this.nickname = _data["nickname"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MachineHead();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["nickname"] = this.nickname;
        data["_id"] = this._id;
        return data;
    }
}
exports.MachineHead = MachineHead;
class StoryOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.restartOnTermination = _data["restartOnTermination"];
            this.restartOnError = _data["restartOnError"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StoryOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["restartOnTermination"] = this.restartOnTermination;
        data["restartOnError"] = this.restartOnError;
        return data;
    }
}
exports.StoryOptions = StoryOptions;
class InitTransitions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["rulesAnd"])) {
                this.rulesAnd = [];
                for (let item of _data["rulesAnd"])
                    this.rulesAnd.push(RulesAnd.fromJS(item));
            }
            this.query = _data["query"];
            this.trigger = _data["trigger"];
            this.target = _data["target"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InitTransitions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rulesAnd)) {
            data["rulesAnd"] = [];
            for (let item of this.rulesAnd)
                data["rulesAnd"].push(item.toJSON());
        }
        data["query"] = this.query;
        data["trigger"] = this.trigger;
        data["target"] = this.target;
        data["_id"] = this._id;
        return data;
    }
}
exports.InitTransitions = InitTransitions;
class GlobalTransitions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["rulesAnd"])) {
                this.rulesAnd = [];
                for (let item of _data["rulesAnd"])
                    this.rulesAnd.push(RulesAnd2.fromJS(item));
            }
            this.query = _data["query"];
            this.trigger = _data["trigger"];
            this.target = _data["target"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalTransitions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rulesAnd)) {
            data["rulesAnd"] = [];
            for (let item of this.rulesAnd)
                data["rulesAnd"].push(item.toJSON());
        }
        data["query"] = this.query;
        data["trigger"] = this.trigger;
        data["target"] = this.target;
        data["_id"] = this._id;
        return data;
    }
}
exports.GlobalTransitions = GlobalTransitions;
class States {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.isSuccessState = false;
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
            this.name = _data["name"];
            this.isSuccessState = _data["isSuccessState"] !== undefined ? _data["isSuccessState"] : false;
            this.runSubStory = _data["runSubStory"] ? RunSubStory.fromJS(_data["runSubStory"]) : undefined;
            this.machinePart = _data["machinePart"] ? MachinePart.fromJS(_data["machinePart"]) : undefined;
            this.subStory = _data["subStory"];
            this.stateEvent = _data["stateEvent"];
            if (Array.isArray(_data["suggestedOptions"])) {
                this.suggestedOptions = [];
                for (let item of _data["suggestedOptions"])
                    this.suggestedOptions.push(SuggestedOptions.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [];
                for (let item of _data["events"])
                    this.events.push(Events.fromJS(item));
            }
            this.content = _data["content"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new States();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["name"] = this.name;
        data["isSuccessState"] = this.isSuccessState;
        data["runSubStory"] = this.runSubStory ? this.runSubStory.toJSON() : undefined;
        data["machinePart"] = this.machinePart ? this.machinePart.toJSON() : undefined;
        data["subStory"] = this.subStory;
        data["stateEvent"] = this.stateEvent;
        if (Array.isArray(this.suggestedOptions)) {
            data["suggestedOptions"] = [];
            for (let item of this.suggestedOptions)
                data["suggestedOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        data["content"] = this.content;
        data["_id"] = this._id;
        return data;
    }
}
exports.States = States;
class Function {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.name = FunctionName.ConversationCommunicator;
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : FunctionName.ConversationCommunicator;
            this.trustedDeveloperJSCodeRef = _data["trustedDeveloperJSCodeRef"];
            this.webhook = _data["webhook"] ? Webhook.fromJS(_data["webhook"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Function();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["trustedDeveloperJSCodeRef"] = this.trustedDeveloperJSCodeRef;
        data["webhook"] = this.webhook ? this.webhook.toJSON() : undefined;
        return data;
    }
}
exports.Function = Function;
class GuiOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.editable = true;
            this.visible = true;
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.editable = _data["editable"] !== undefined ? _data["editable"] : true;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : true;
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GuiOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["editable"] = this.editable;
        data["visible"] = this.visible;
        data["position"] = this.position ? this.position.toJSON() : undefined;
        return data;
    }
}
exports.GuiOptions = GuiOptions;
class TouchPoints {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.tpKey = "de";
        }
    }
    init(_data) {
        if (_data) {
            this.tpKey = _data["tpKey"] !== undefined ? _data["tpKey"] : "de";
            this.isDefault = _data["isDefault"];
            this.fallback = _data["fallback"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TouchPoints();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tpKey"] = this.tpKey;
        data["isDefault"] = this.isDefault;
        data["fallback"] = this.fallback;
        data["_id"] = this._id;
        return data;
    }
}
exports.TouchPoints = TouchPoints;
class Substory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.flags = _data["flags"];
            if (Array.isArray(_data["states"])) {
                this.states = [];
                for (let item of _data["states"])
                    this.states.push(States2.fromJS(item));
            }
            this.slotKind = _data["slotKind"];
            this.slotName = _data["slotName"];
            this.runLogic = _data["runLogic"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Substory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["flags"] = this.flags;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        data["slotKind"] = this.slotKind;
        data["slotName"] = this.slotName;
        data["runLogic"] = this.runLogic;
        return data;
    }
}
exports.Substory = Substory;
class BotFunction {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.functionName = _data["functionName"];
            this.webhook = _data["webhook"] ? Webhook2.fromJS(_data["webhook"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BotFunction();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["functionName"] = this.functionName;
        data["webhook"] = this.webhook ? this.webhook.toJSON() : undefined;
        return data;
    }
}
exports.BotFunction = BotFunction;
class Classification {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["microintends"])) {
                this.microintends = [];
                for (let item of _data["microintends"])
                    this.microintends.push(item);
            }
            this.micromacro = _data["micromacro"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Classification();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.microintends)) {
            data["microintends"] = [];
            for (let item of this.microintends)
                data["microintends"].push(item);
        }
        data["micromacro"] = this.micromacro;
        return data;
    }
}
exports.Classification = Classification;
class Dictionary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.input = _data["input"];
            this.output = _data["output"];
            this.fuzzyEncode = _data["fuzzyEncode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Dictionary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        data["output"] = this.output;
        data["fuzzyEncode"] = this.fuzzyEncode;
        return data;
    }
}
exports.Dictionary = Dictionary;
var MlModelLogicEngine;
(function (MlModelLogicEngine) {
    MlModelLogicEngine["AgileNeuroDescider"] = "agileNeuroDescider";
    MlModelLogicEngine["AgileFastWeights"] = "agileFastWeights";
    MlModelLogicEngine["AgileMatrix"] = "agileMatrix";
    MlModelLogicEngine["AgileIntentNLP"] = "agileIntentNLP";
    MlModelLogicEngine["AgileSearchIndex"] = "agileSearchIndex";
})(MlModelLogicEngine = exports.MlModelLogicEngine || (exports.MlModelLogicEngine = {}));
class ModelDownloadUrls {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
            this.params = _data["params"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ModelDownloadUrls();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["params"] = this.params;
        data["_id"] = this._id;
        return data;
    }
}
exports.ModelDownloadUrls = ModelDownloadUrls;
class Logs {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["core"])) {
                this.core = [];
                for (let item of _data["core"])
                    this.core.push(item);
            }
            if (Array.isArray(_data["functions"])) {
                this.functions = [];
                for (let item of _data["functions"])
                    this.functions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Logs();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.core)) {
            data["core"] = [];
            for (let item of this.core)
                data["core"].push(item);
        }
        if (Array.isArray(this.functions)) {
            data["functions"] = [];
            for (let item of this.functions)
                data["functions"].push(item);
        }
        return data;
    }
}
exports.Logs = Logs;
class ErrorCases {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["core"])) {
                this.core = [];
                for (let item of _data["core"])
                    this.core.push(Core.fromJS(item));
            }
            if (Array.isArray(_data["functions"])) {
                this.functions = [];
                for (let item of _data["functions"])
                    this.functions.push(Functions.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorCases();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.core)) {
            data["core"] = [];
            for (let item of this.core)
                data["core"].push(item.toJSON());
        }
        if (Array.isArray(this.functions)) {
            data["functions"] = [];
            for (let item of this.functions)
                data["functions"].push(item.toJSON());
        }
        return data;
    }
}
exports.ErrorCases = ErrorCases;
class ErrorDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrors2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }
}
exports.ErrorDto = ErrorDto;
class RulesAnd {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["itemsOr"])) {
                this.itemsOr = [];
                for (let item of _data["itemsOr"])
                    this.itemsOr.push(ItemsOr.fromJS(item));
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RulesAnd();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsOr)) {
            data["itemsOr"] = [];
            for (let item of this.itemsOr)
                data["itemsOr"].push(item.toJSON());
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.RulesAnd = RulesAnd;
class RulesAnd2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["itemsOr"])) {
                this.itemsOr = [];
                for (let item of _data["itemsOr"])
                    this.itemsOr.push(ItemsOr2.fromJS(item));
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RulesAnd2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsOr)) {
            data["itemsOr"] = [];
            for (let item of this.itemsOr)
                data["itemsOr"].push(item.toJSON());
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.RulesAnd2 = RulesAnd2;
class RunSubStory {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refId = _data["refId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RunSubStory();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        return data;
    }
}
exports.RunSubStory = RunSubStory;
class MachinePart {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.waitForInteraction = false;
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.waitForInteraction = _data["waitForInteraction"] !== undefined ? _data["waitForInteraction"] : false;
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [];
                for (let item of _data["transitions"])
                    this.transitions.push(Transitions.fromJS(item));
            }
            this.actions = _data["actions"] ? Actions.fromJS(_data["actions"]) : undefined;
            this.dataStoreTransactions = _data["dataStoreTransactions"] ? DataStoreTransactions.fromJS(_data["dataStoreTransactions"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MachinePart();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["waitForInteraction"] = this.waitForInteraction;
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item.toJSON());
        }
        data["actions"] = this.actions ? this.actions.toJSON() : undefined;
        data["dataStoreTransactions"] = this.dataStoreTransactions ? this.dataStoreTransactions.toJSON() : undefined;
        return data;
    }
}
exports.MachinePart = MachinePart;
class SuggestedOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.name = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["name"])) {
                this.name = [];
                for (let item of _data["name"])
                    this.name.push(Name.fromJS(item));
            }
            this.clickId = _data["clickId"];
            this.groupId = _data["groupId"];
            this.visabiltyExpression = _data["visabiltyExpression"];
            this.data = _data["data"];
            this.dataStoreTransactions = _data["dataStoreTransactions"] ? DataStoreTransactions2.fromJS(_data["dataStoreTransactions"]) : undefined;
            this.content = _data["content"];
            this.nodeItemSourceId = _data["nodeItemSourceId"];
            this.stateEvent = _data["stateEvent"];
            this.event = _data["event"];
            if (Array.isArray(_data["microIntends"])) {
                this.microIntends = [];
                for (let item of _data["microIntends"])
                    this.microIntends.push(MicroIntends.fromJS(item));
            }
            if (Array.isArray(_data["triggedByMicroIntends"])) {
                this.triggedByMicroIntends = [];
                for (let item of _data["triggedByMicroIntends"])
                    this.triggedByMicroIntends.push(TriggedByMicroIntends.fromJS(item));
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestedOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item.toJSON());
        }
        data["clickId"] = this.clickId;
        data["groupId"] = this.groupId;
        data["visabiltyExpression"] = this.visabiltyExpression;
        data["data"] = this.data;
        data["dataStoreTransactions"] = this.dataStoreTransactions ? this.dataStoreTransactions.toJSON() : undefined;
        data["content"] = this.content;
        data["nodeItemSourceId"] = this.nodeItemSourceId;
        data["stateEvent"] = this.stateEvent;
        data["event"] = this.event;
        if (Array.isArray(this.microIntends)) {
            data["microIntends"] = [];
            for (let item of this.microIntends)
                data["microIntends"].push(item.toJSON());
        }
        if (Array.isArray(this.triggedByMicroIntends)) {
            data["triggedByMicroIntends"] = [];
            for (let item of this.triggedByMicroIntends)
                data["triggedByMicroIntends"].push(item.toJSON());
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.SuggestedOptions = SuggestedOptions;
class Events {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.timeoutSeconds = 0;
            this.iterations = 0;
            this.spawnReturningSubstory = false;
            this.scope = EventsScope.ThisNodeItem;
        }
    }
    init(_data) {
        if (_data) {
            this.refId = _data["refId"];
            this.timeoutSeconds = _data["timeoutSeconds"] !== undefined ? _data["timeoutSeconds"] : 0;
            this.iterations = _data["iterations"] !== undefined ? _data["iterations"] : 0;
            this.spawnReturningSubstory = _data["spawnReturningSubstory"] !== undefined ? _data["spawnReturningSubstory"] : false;
            this.scope = _data["scope"] !== undefined ? _data["scope"] : EventsScope.ThisNodeItem;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Events();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["timeoutSeconds"] = this.timeoutSeconds;
        data["iterations"] = this.iterations;
        data["spawnReturningSubstory"] = this.spawnReturningSubstory;
        data["scope"] = this.scope;
        data["_id"] = this._id;
        return data;
    }
}
exports.Events = Events;
var FunctionName;
(function (FunctionName) {
    FunctionName["ConversationCommunicator"] = "conversationCommunicator";
    FunctionName["TrustedDeveloperJSCodeRunner"] = "trustedDeveloperJSCodeRunner";
    FunctionName["Map_nodeItems_parallel"] = "map_nodeItems_parallel";
})(FunctionName = exports.FunctionName || (exports.FunctionName = {}));
class Webhook {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.api = _data["api"] ? Api.fromJS(_data["api"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Webhook();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["api"] = this.api ? this.api.toJSON() : undefined;
        return data;
    }
}
exports.Webhook = Webhook;
class Position {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.x = 250;
            this.y = 250;
            this.colapsed = true;
        }
    }
    init(_data) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : 250;
            this.y = _data["y"] !== undefined ? _data["y"] : 250;
            this.colapsed = _data["colapsed"] !== undefined ? _data["colapsed"] : true;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Position();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["colapsed"] = this.colapsed;
        return data;
    }
}
exports.Position = Position;
class States2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.gui = "textarea";
        }
    }
    init(_data) {
        if (_data) {
            this.state = _data["state"];
            this.output = _data["output"];
            this.iterations = _data["iterations"];
            this.gui = _data["gui"] !== undefined ? _data["gui"] : "textarea";
            this.event = _data["event"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new States2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["output"] = this.output;
        data["iterations"] = this.iterations;
        data["gui"] = this.gui;
        data["event"] = this.event;
        data["_id"] = this._id;
        return data;
    }
}
exports.States2 = States2;
class Webhook2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.api = _data["api"] ? Api2.fromJS(_data["api"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Webhook2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["api"] = this.api ? this.api.toJSON() : undefined;
        return data;
    }
}
exports.Webhook2 = Webhook2;
class Core {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nodeItemRefIdobj = _data["nodeItemRefIdobj"];
            this.nodeItemId = _data["nodeItemId"];
            this.functionRefId = _data["functionRefId"];
            this.modelRefId = _data["modelRefId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.statusCode = _data["statusCode"];
            this.exception = _data["exception"];
            this.stack = _data["stack"];
            this.data = _data["data"];
            this.t = _data["t"] ? new Date(_data["t"].toString()) : undefined;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Core();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nodeItemRefIdobj"] = this.nodeItemRefIdobj;
        data["nodeItemId"] = this.nodeItemId;
        data["functionRefId"] = this.functionRefId;
        data["modelRefId"] = this.modelRefId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["statusCode"] = this.statusCode;
        data["exception"] = this.exception;
        data["stack"] = this.stack;
        data["data"] = this.data;
        data["t"] = this.t ? this.t.toISOString() : undefined;
        data["_id"] = this._id;
        return data;
    }
}
exports.Core = Core;
class Functions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nodeItemRefIdobj = _data["nodeItemRefIdobj"];
            this.nodeItemId = _data["nodeItemId"];
            this.functionRefId = _data["functionRefId"];
            this.modelRefId = _data["modelRefId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.statusCode = _data["statusCode"];
            this.exception = _data["exception"];
            this.stack = _data["stack"];
            this.data = _data["data"];
            this.t = _data["t"] ? new Date(_data["t"].toString()) : undefined;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Functions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nodeItemRefIdobj"] = this.nodeItemRefIdobj;
        data["nodeItemId"] = this.nodeItemId;
        data["functionRefId"] = this.functionRefId;
        data["modelRefId"] = this.modelRefId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["statusCode"] = this.statusCode;
        data["exception"] = this.exception;
        data["stack"] = this.stack;
        data["data"] = this.data;
        data["t"] = this.t ? this.t.toISOString() : undefined;
        data["_id"] = this._id;
        return data;
    }
}
exports.Functions = Functions;
class ValidationErrors2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.message = _data["message"];
            this.kind = _data["kind"];
            this.path = _data["path"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrors2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["kind"] = this.kind;
        data["path"] = this.path;
        return data;
    }
}
exports.ValidationErrors2 = ValidationErrors2;
class ItemsOr {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.source = _data["source"];
            this.sentiment = _data["sentiment"];
            this.key = _data["key"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemsOr();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["sentiment"] = this.sentiment;
        data["key"] = this.key;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["_id"] = this._id;
        return data;
    }
}
exports.ItemsOr = ItemsOr;
class ItemsOr2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.source = _data["source"];
            this.sentiment = _data["sentiment"];
            this.key = _data["key"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemsOr2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["sentiment"] = this.sentiment;
        data["key"] = this.key;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["_id"] = this._id;
        return data;
    }
}
exports.ItemsOr2 = ItemsOr2;
class Transitions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.shouldRender = true;
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["rulesAnd"])) {
                this.rulesAnd = [];
                for (let item of _data["rulesAnd"])
                    this.rulesAnd.push(RulesAnd3.fromJS(item));
            }
            this.trigger = _data["trigger"];
            this.query = _data["query"];
            if (Array.isArray(_data["intents"])) {
                this.intents = [];
                for (let item of _data["intents"])
                    this.intents.push(item);
            }
            this.event = _data["event"];
            this.target = _data["target"];
            this.shouldRender = _data["shouldRender"] !== undefined ? _data["shouldRender"] : true;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Transitions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rulesAnd)) {
            data["rulesAnd"] = [];
            for (let item of this.rulesAnd)
                data["rulesAnd"].push(item.toJSON());
        }
        data["trigger"] = this.trigger;
        data["query"] = this.query;
        if (Array.isArray(this.intents)) {
            data["intents"] = [];
            for (let item of this.intents)
                data["intents"].push(item);
        }
        data["event"] = this.event;
        data["target"] = this.target;
        data["shouldRender"] = this.shouldRender;
        data["_id"] = this._id;
        return data;
    }
}
exports.Transitions = Transitions;
class Actions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["entry"])) {
                this.entry = [];
                for (let item of _data["entry"])
                    this.entry.push(Entry.fromJS(item));
            }
            if (Array.isArray(_data["interaction"])) {
                this.interaction = [];
                for (let item of _data["interaction"])
                    this.interaction.push(Interaction.fromJS(item));
            }
            if (Array.isArray(_data["exit"])) {
                this.exit = [];
                for (let item of _data["exit"])
                    this.exit.push(Exit.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Actions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entry)) {
            data["entry"] = [];
            for (let item of this.entry)
                data["entry"].push(item.toJSON());
        }
        if (Array.isArray(this.interaction)) {
            data["interaction"] = [];
            for (let item of this.interaction)
                data["interaction"].push(item.toJSON());
        }
        if (Array.isArray(this.exit)) {
            data["exit"] = [];
            for (let item of this.exit)
                data["exit"].push(item.toJSON());
        }
        return data;
    }
}
exports.Actions = Actions;
class DataStoreTransactions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.entry = _data["entry"] ? Entry2.fromJS(_data["entry"]) : undefined;
            this.interaction = _data["interaction"] ? Interaction2.fromJS(_data["interaction"]) : undefined;
            this.exit = _data["exit"] ? Exit2.fromJS(_data["exit"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataStoreTransactions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry ? this.entry.toJSON() : undefined;
        data["interaction"] = this.interaction ? this.interaction.toJSON() : undefined;
        data["exit"] = this.exit ? this.exit.toJSON() : undefined;
        return data;
    }
}
exports.DataStoreTransactions = DataStoreTransactions;
class Name {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tpKey = _data["tpKey"];
            this.tpValue = _data["tpValue"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Name();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tpKey"] = this.tpKey;
        data["tpValue"] = this.tpValue;
        data["_id"] = this._id;
        return data;
    }
}
exports.Name = Name;
class DataStoreTransactions2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["add"])) {
                this.add = [];
                for (let item of _data["add"])
                    this.add.push(Add.fromJS(item));
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [];
                for (let item of _data["remove"])
                    this.remove.push(Remove.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DataStoreTransactions2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.add)) {
            data["add"] = [];
            for (let item of this.add)
                data["add"].push(item.toJSON());
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (let item of this.remove)
                data["remove"].push(item.toJSON());
        }
        return data;
    }
}
exports.DataStoreTransactions2 = DataStoreTransactions2;
class MicroIntends {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.microIntend = _data["microIntend"];
            this.state = _data["state"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MicroIntends();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["microIntend"] = this.microIntend;
        data["state"] = this.state;
        data["_id"] = this._id;
        return data;
    }
}
exports.MicroIntends = MicroIntends;
class TriggedByMicroIntends {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.microIntend = _data["microIntend"];
            this.state = _data["state"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TriggedByMicroIntends();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["microIntend"] = this.microIntend;
        data["state"] = this.state;
        data["_id"] = this._id;
        return data;
    }
}
exports.TriggedByMicroIntends = TriggedByMicroIntends;
var EventsScope;
(function (EventsScope) {
    EventsScope["This_state"] = "this state";
    EventsScope["ThisNodeItem"] = "thisNodeItem";
    EventsScope["Always"] = "always";
})(EventsScope = exports.EventsScope || (exports.EventsScope = {}));
class Api {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
            if (Array.isArray(_data["Params"])) {
                this.params = [];
                for (let item of _data["Params"])
                    this.params.push(Params.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Api();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        if (Array.isArray(this.params)) {
            data["Params"] = [];
            for (let item of this.params)
                data["Params"].push(item.toJSON());
        }
        return data;
    }
}
exports.Api = Api;
class Api2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
            this.xApiKey = _data["XApiKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Api2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["XApiKey"] = this.xApiKey;
        return data;
    }
}
exports.Api2 = Api2;
var ItemsOrSource;
(function (ItemsOrSource) {
    ItemsOrSource["DataStore_currentValue"] = "dataStore.currentValue";
    ItemsOrSource["DataStore_history"] = "dataStore.history";
    ItemsOrSource["Intent_name"] = "intent.name";
    ItemsOrSource["SuggestedOption_clickId"] = "suggestedOption.clickId";
    ItemsOrSource["Text_raw"] = "text.raw";
    ItemsOrSource["Text_token"] = "text.token";
    ItemsOrSource["Text_email"] = "text.email";
    ItemsOrSource["Text_number"] = "text.number";
    ItemsOrSource["Text_date"] = "text.date";
    ItemsOrSource["ALWAYS_TRUE"] = "ALWAYS_TRUE";
})(ItemsOrSource = exports.ItemsOrSource || (exports.ItemsOrSource = {}));
var ItemsOrSentiment;
(function (ItemsOrSentiment) {
    ItemsOrSentiment["Positive"] = "positive";
    ItemsOrSentiment["Negative"] = "negative";
})(ItemsOrSentiment = exports.ItemsOrSentiment || (exports.ItemsOrSentiment = {}));
var ItemsOrOperator;
(function (ItemsOrOperator) {
    ItemsOrOperator["Exists"] = "exists";
    ItemsOrOperator["ExistsNot"] = "existsNot";
    ItemsOrOperator["Equals"] = "equals";
    ItemsOrOperator["EqualsNot"] = "equalsNot";
    ItemsOrOperator["StartsWith"] = "startsWith";
    ItemsOrOperator["StartsNotWith"] = "startsNotWith";
    ItemsOrOperator["Contains"] = "contains";
    ItemsOrOperator["ContainsNot"] = "containsNot";
    ItemsOrOperator["DateFrom"] = "dateFrom";
    ItemsOrOperator["DateTo"] = "dateTo";
})(ItemsOrOperator = exports.ItemsOrOperator || (exports.ItemsOrOperator = {}));
var ItemsOr2Source;
(function (ItemsOr2Source) {
    ItemsOr2Source["DataStore_currentValue"] = "dataStore.currentValue";
    ItemsOr2Source["DataStore_history"] = "dataStore.history";
    ItemsOr2Source["Intent_name"] = "intent.name";
    ItemsOr2Source["SuggestedOption_clickId"] = "suggestedOption.clickId";
    ItemsOr2Source["Text_raw"] = "text.raw";
    ItemsOr2Source["Text_token"] = "text.token";
    ItemsOr2Source["Text_email"] = "text.email";
    ItemsOr2Source["Text_number"] = "text.number";
    ItemsOr2Source["Text_date"] = "text.date";
    ItemsOr2Source["ALWAYS_TRUE"] = "ALWAYS_TRUE";
})(ItemsOr2Source = exports.ItemsOr2Source || (exports.ItemsOr2Source = {}));
var ItemsOr2Sentiment;
(function (ItemsOr2Sentiment) {
    ItemsOr2Sentiment["Positive"] = "positive";
    ItemsOr2Sentiment["Negative"] = "negative";
})(ItemsOr2Sentiment = exports.ItemsOr2Sentiment || (exports.ItemsOr2Sentiment = {}));
var ItemsOr2Operator;
(function (ItemsOr2Operator) {
    ItemsOr2Operator["Exists"] = "exists";
    ItemsOr2Operator["ExistsNot"] = "existsNot";
    ItemsOr2Operator["Equals"] = "equals";
    ItemsOr2Operator["EqualsNot"] = "equalsNot";
    ItemsOr2Operator["StartsWith"] = "startsWith";
    ItemsOr2Operator["StartsNotWith"] = "startsNotWith";
    ItemsOr2Operator["Contains"] = "contains";
    ItemsOr2Operator["ContainsNot"] = "containsNot";
    ItemsOr2Operator["DateFrom"] = "dateFrom";
    ItemsOr2Operator["DateTo"] = "dateTo";
})(ItemsOr2Operator = exports.ItemsOr2Operator || (exports.ItemsOr2Operator = {}));
class RulesAnd3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["itemsOr"])) {
                this.itemsOr = [];
                for (let item of _data["itemsOr"])
                    this.itemsOr.push(ItemsOr3.fromJS(item));
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RulesAnd3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsOr)) {
            data["itemsOr"] = [];
            for (let item of this.itemsOr)
                data["itemsOr"].push(item.toJSON());
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.RulesAnd3 = RulesAnd3;
class Entry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["params"])) {
                this.params = [];
                for (let item of _data["params"])
                    this.params.push(item);
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Entry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.params)) {
            data["params"] = [];
            for (let item of this.params)
                data["params"].push(item);
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.Entry = Entry;
class Interaction {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["params"])) {
                this.params = [];
                for (let item of _data["params"])
                    this.params.push(item);
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Interaction();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.params)) {
            data["params"] = [];
            for (let item of this.params)
                data["params"].push(item);
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.Interaction = Interaction;
class Exit {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["params"])) {
                this.params = [];
                for (let item of _data["params"])
                    this.params.push(item);
            }
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Exit();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.params)) {
            data["params"] = [];
            for (let item of this.params)
                data["params"].push(item);
        }
        data["_id"] = this._id;
        return data;
    }
}
exports.Exit = Exit;
class Entry2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["add"])) {
                this.add = [];
                for (let item of _data["add"])
                    this.add.push(Add2.fromJS(item));
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [];
                for (let item of _data["remove"])
                    this.remove.push(Remove2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Entry2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.add)) {
            data["add"] = [];
            for (let item of this.add)
                data["add"].push(item.toJSON());
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (let item of this.remove)
                data["remove"].push(item.toJSON());
        }
        return data;
    }
}
exports.Entry2 = Entry2;
class Interaction2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["add"])) {
                this.add = [];
                for (let item of _data["add"])
                    this.add.push(Add3.fromJS(item));
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [];
                for (let item of _data["remove"])
                    this.remove.push(Remove3.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Interaction2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.add)) {
            data["add"] = [];
            for (let item of this.add)
                data["add"].push(item.toJSON());
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (let item of this.remove)
                data["remove"].push(item.toJSON());
        }
        return data;
    }
}
exports.Interaction2 = Interaction2;
class Exit2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["add"])) {
                this.add = [];
                for (let item of _data["add"])
                    this.add.push(Add4.fromJS(item));
            }
            if (Array.isArray(_data["remove"])) {
                this.remove = [];
                for (let item of _data["remove"])
                    this.remove.push(Remove4.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Exit2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.add)) {
            data["add"] = [];
            for (let item of this.add)
                data["add"].push(item.toJSON());
        }
        if (Array.isArray(this.remove)) {
            data["remove"] = [];
            for (let item of this.remove)
                data["remove"].push(item.toJSON());
        }
        return data;
    }
}
exports.Exit2 = Exit2;
class Add {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = AddSource.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : AddSource.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Add();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Add = Add;
class Remove {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = RemoveSource.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl2.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : RemoveSource.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Remove();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Remove = Remove;
class Params {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.type = ParamsType.Header;
            this.source = ParamsSource.Value;
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : ParamsType.Header;
            this.key = _data["key"];
            this.value = _data["value"];
            this.source = _data["source"] !== undefined ? _data["source"] : ParamsSource.Value;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Params();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["key"] = this.key;
        data["value"] = this.value;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Params = Params;
class ItemsOr3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.source = _data["source"];
            this.sentiment = _data["sentiment"];
            this.key = _data["key"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemsOr3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["sentiment"] = this.sentiment;
        data["key"] = this.key;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["_id"] = this._id;
        return data;
    }
}
exports.ItemsOr3 = ItemsOr3;
class Add2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = Add2Source.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl3.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : Add2Source.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Add2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Add2 = Add2;
class Remove2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = Remove2Source.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl4.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : Remove2Source.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Remove2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Remove2 = Remove2;
class Add3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = Add3Source.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl5.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : Add3Source.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Add3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Add3 = Add3;
class Remove3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = Remove3Source.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl6.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : Remove3Source.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Remove3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Remove3 = Remove3;
class Add4 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = Add4Source.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl7.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : Add4Source.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Add4();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Add4 = Add4;
class Remove4 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.source = Remove4Source.BaiCore;
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.path = _data["path"];
            this.ttl = _data["ttl"] ? Ttl8.fromJS(_data["ttl"]) : undefined;
            this.source = _data["source"] !== undefined ? _data["source"] : Remove4Source.BaiCore;
            this._id = _data["_id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Remove4();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["path"] = this.path;
        data["ttl"] = this.ttl ? this.ttl.toJSON() : undefined;
        data["source"] = this.source;
        data["_id"] = this._id;
        return data;
    }
}
exports.Remove4 = Remove4;
class Ttl {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = TtlUnit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : TtlUnit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl = Ttl;
var AddSource;
(function (AddSource) {
    AddSource["SuggestedOption"] = "suggestedOption";
    AddSource["BaiCore"] = "baiCore";
    AddSource["CurrentState"] = "currentState";
    AddSource["DataStore"] = "dataStore";
})(AddSource = exports.AddSource || (exports.AddSource = {}));
class Ttl2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl2Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl2Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl2 = Ttl2;
var RemoveSource;
(function (RemoveSource) {
    RemoveSource["SuggestedOption"] = "suggestedOption";
    RemoveSource["BaiCore"] = "baiCore";
    RemoveSource["CurrentState"] = "currentState";
    RemoveSource["DataStore"] = "dataStore";
})(RemoveSource = exports.RemoveSource || (exports.RemoveSource = {}));
var ParamsType;
(function (ParamsType) {
    ParamsType["Header"] = "header";
    ParamsType["Url"] = "url";
    ParamsType["Body"] = "body";
})(ParamsType = exports.ParamsType || (exports.ParamsType = {}));
var ParamsSource;
(function (ParamsSource) {
    ParamsSource["Value"] = "value";
    ParamsSource["ENVIRONMENTVARIABLE"] = "ENVIRONMENTVARIABLE";
    ParamsSource["AICONTEXT"] = "AICONTEXT";
})(ParamsSource = exports.ParamsSource || (exports.ParamsSource = {}));
var ItemsOr3Source;
(function (ItemsOr3Source) {
    ItemsOr3Source["DataStore_currentValue"] = "dataStore.currentValue";
    ItemsOr3Source["DataStore_history"] = "dataStore.history";
    ItemsOr3Source["Intent_name"] = "intent.name";
    ItemsOr3Source["SuggestedOption_clickId"] = "suggestedOption.clickId";
    ItemsOr3Source["Text_raw"] = "text.raw";
    ItemsOr3Source["Text_token"] = "text.token";
    ItemsOr3Source["Text_email"] = "text.email";
    ItemsOr3Source["Text_number"] = "text.number";
    ItemsOr3Source["Text_date"] = "text.date";
    ItemsOr3Source["ALWAYS_TRUE"] = "ALWAYS_TRUE";
})(ItemsOr3Source = exports.ItemsOr3Source || (exports.ItemsOr3Source = {}));
var ItemsOr3Sentiment;
(function (ItemsOr3Sentiment) {
    ItemsOr3Sentiment["Positive"] = "positive";
    ItemsOr3Sentiment["Negative"] = "negative";
})(ItemsOr3Sentiment = exports.ItemsOr3Sentiment || (exports.ItemsOr3Sentiment = {}));
var ItemsOr3Operator;
(function (ItemsOr3Operator) {
    ItemsOr3Operator["Exists"] = "exists";
    ItemsOr3Operator["ExistsNot"] = "existsNot";
    ItemsOr3Operator["Equals"] = "equals";
    ItemsOr3Operator["EqualsNot"] = "equalsNot";
    ItemsOr3Operator["StartsWith"] = "startsWith";
    ItemsOr3Operator["StartsNotWith"] = "startsNotWith";
    ItemsOr3Operator["Contains"] = "contains";
    ItemsOr3Operator["ContainsNot"] = "containsNot";
    ItemsOr3Operator["DateFrom"] = "dateFrom";
    ItemsOr3Operator["DateTo"] = "dateTo";
})(ItemsOr3Operator = exports.ItemsOr3Operator || (exports.ItemsOr3Operator = {}));
class Ttl3 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl3Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl3Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl3();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl3 = Ttl3;
var Add2Source;
(function (Add2Source) {
    Add2Source["SuggestedOption"] = "suggestedOption";
    Add2Source["BaiCore"] = "baiCore";
    Add2Source["CurrentState"] = "currentState";
    Add2Source["DataStore"] = "dataStore";
})(Add2Source = exports.Add2Source || (exports.Add2Source = {}));
class Ttl4 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl4Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl4Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl4();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl4 = Ttl4;
var Remove2Source;
(function (Remove2Source) {
    Remove2Source["SuggestedOption"] = "suggestedOption";
    Remove2Source["BaiCore"] = "baiCore";
    Remove2Source["CurrentState"] = "currentState";
    Remove2Source["DataStore"] = "dataStore";
})(Remove2Source = exports.Remove2Source || (exports.Remove2Source = {}));
class Ttl5 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl5Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl5Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl5();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl5 = Ttl5;
var Add3Source;
(function (Add3Source) {
    Add3Source["SuggestedOption"] = "suggestedOption";
    Add3Source["BaiCore"] = "baiCore";
    Add3Source["CurrentState"] = "currentState";
    Add3Source["DataStore"] = "dataStore";
})(Add3Source = exports.Add3Source || (exports.Add3Source = {}));
class Ttl6 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl6Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl6Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl6();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl6 = Ttl6;
var Remove3Source;
(function (Remove3Source) {
    Remove3Source["SuggestedOption"] = "suggestedOption";
    Remove3Source["BaiCore"] = "baiCore";
    Remove3Source["CurrentState"] = "currentState";
    Remove3Source["DataStore"] = "dataStore";
})(Remove3Source = exports.Remove3Source || (exports.Remove3Source = {}));
class Ttl7 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl7Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl7Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl7();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl7 = Ttl7;
var Add4Source;
(function (Add4Source) {
    Add4Source["SuggestedOption"] = "suggestedOption";
    Add4Source["BaiCore"] = "baiCore";
    Add4Source["CurrentState"] = "currentState";
    Add4Source["DataStore"] = "dataStore";
})(Add4Source = exports.Add4Source || (exports.Add4Source = {}));
class Ttl8 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.unit = Ttl8Unit.Milliseconds;
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.unit = _data["unit"] !== undefined ? _data["unit"] : Ttl8Unit.Milliseconds;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ttl8();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}
exports.Ttl8 = Ttl8;
var Remove4Source;
(function (Remove4Source) {
    Remove4Source["SuggestedOption"] = "suggestedOption";
    Remove4Source["BaiCore"] = "baiCore";
    Remove4Source["CurrentState"] = "currentState";
    Remove4Source["DataStore"] = "dataStore";
})(Remove4Source = exports.Remove4Source || (exports.Remove4Source = {}));
var TtlUnit;
(function (TtlUnit) {
    TtlUnit["Milliseconds"] = "milliseconds";
    TtlUnit["Seconds"] = "seconds";
    TtlUnit["Minutes"] = "minutes";
    TtlUnit["Hours"] = "hours";
    TtlUnit["Days"] = "days";
    TtlUnit["Months"] = "months";
    TtlUnit["Years"] = "years";
})(TtlUnit = exports.TtlUnit || (exports.TtlUnit = {}));
var Ttl2Unit;
(function (Ttl2Unit) {
    Ttl2Unit["Milliseconds"] = "milliseconds";
    Ttl2Unit["Seconds"] = "seconds";
    Ttl2Unit["Minutes"] = "minutes";
    Ttl2Unit["Hours"] = "hours";
    Ttl2Unit["Days"] = "days";
    Ttl2Unit["Months"] = "months";
    Ttl2Unit["Years"] = "years";
})(Ttl2Unit = exports.Ttl2Unit || (exports.Ttl2Unit = {}));
var Ttl3Unit;
(function (Ttl3Unit) {
    Ttl3Unit["Milliseconds"] = "milliseconds";
    Ttl3Unit["Seconds"] = "seconds";
    Ttl3Unit["Minutes"] = "minutes";
    Ttl3Unit["Hours"] = "hours";
    Ttl3Unit["Days"] = "days";
    Ttl3Unit["Months"] = "months";
    Ttl3Unit["Years"] = "years";
})(Ttl3Unit = exports.Ttl3Unit || (exports.Ttl3Unit = {}));
var Ttl4Unit;
(function (Ttl4Unit) {
    Ttl4Unit["Milliseconds"] = "milliseconds";
    Ttl4Unit["Seconds"] = "seconds";
    Ttl4Unit["Minutes"] = "minutes";
    Ttl4Unit["Hours"] = "hours";
    Ttl4Unit["Days"] = "days";
    Ttl4Unit["Months"] = "months";
    Ttl4Unit["Years"] = "years";
})(Ttl4Unit = exports.Ttl4Unit || (exports.Ttl4Unit = {}));
var Ttl5Unit;
(function (Ttl5Unit) {
    Ttl5Unit["Milliseconds"] = "milliseconds";
    Ttl5Unit["Seconds"] = "seconds";
    Ttl5Unit["Minutes"] = "minutes";
    Ttl5Unit["Hours"] = "hours";
    Ttl5Unit["Days"] = "days";
    Ttl5Unit["Months"] = "months";
    Ttl5Unit["Years"] = "years";
})(Ttl5Unit = exports.Ttl5Unit || (exports.Ttl5Unit = {}));
var Ttl6Unit;
(function (Ttl6Unit) {
    Ttl6Unit["Milliseconds"] = "milliseconds";
    Ttl6Unit["Seconds"] = "seconds";
    Ttl6Unit["Minutes"] = "minutes";
    Ttl6Unit["Hours"] = "hours";
    Ttl6Unit["Days"] = "days";
    Ttl6Unit["Months"] = "months";
    Ttl6Unit["Years"] = "years";
})(Ttl6Unit = exports.Ttl6Unit || (exports.Ttl6Unit = {}));
var Ttl7Unit;
(function (Ttl7Unit) {
    Ttl7Unit["Milliseconds"] = "milliseconds";
    Ttl7Unit["Seconds"] = "seconds";
    Ttl7Unit["Minutes"] = "minutes";
    Ttl7Unit["Hours"] = "hours";
    Ttl7Unit["Days"] = "days";
    Ttl7Unit["Months"] = "months";
    Ttl7Unit["Years"] = "years";
})(Ttl7Unit = exports.Ttl7Unit || (exports.Ttl7Unit = {}));
var Ttl8Unit;
(function (Ttl8Unit) {
    Ttl8Unit["Milliseconds"] = "milliseconds";
    Ttl8Unit["Seconds"] = "seconds";
    Ttl8Unit["Minutes"] = "minutes";
    Ttl8Unit["Hours"] = "hours";
    Ttl8Unit["Days"] = "days";
    Ttl8Unit["Months"] = "months";
    Ttl8Unit["Years"] = "years";
})(Ttl8Unit = exports.Ttl8Unit || (exports.Ttl8Unit = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
//# sourceMappingURL=TrainerServerApiClient.js.map